var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"links"},[_vm._v("\n    Ant Design Vue "+_vm._s(_vm.version)+"\n  ")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright"},[_c('span',[_vm._v("Xuz")])])
}]

export { render, staticRenderFns }